import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { IconType } from 'react-icons'
import { FaChevronDown } from 'react-icons/fa'

interface MenuItem { 
	name: string, 
	active: boolean,
  icon: IconType,
  themeColor?: string
}
type DropdownProps = {
  title?: string,
  menus?: MenuItem [],
  disabled?: boolean,
  classNameBtn?: string,
  onMenuSelected: (menu: string) => void
}

const DropdownGeneral = ({
  title = 'เริ่มบันทึก',
  menus = [],
  classNameBtn = 'inline-flex justify-center w-full px-2 py-1.5 text-sm text-white disabled:text-blue-500 disabled:text-opacity-60 duration-300 bg-blue-500 disabled:bg-white rounded hover:bg-blue-600 disabled:border disabled:border-blue-500',
  disabled = false,
  onMenuSelected
} : DropdownProps) => (
  <Menu as="div" className="relative inline-block text-left">
    <div>
      <Menu.Button className={classNameBtn}
        disabled={disabled}>
        {title}
        <FaChevronDown className="w-4 h-4 mt-0.5 ml-2 -mr-1"/>
      </Menu.Button>
    </div>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items className="absolute right-0 z-50 w-48 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="px-1 py-1">
          {menus.map(menu => (
            <Menu.Item key={menu.name} disabled={!menu.active} >
              {({ active, disabled }) => (
                <button
                  className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                  } group flex gap-1 rounded-md items-center w-full px-2 py-2 text-sm${disabled ? ' opacity-40': ''}`}
                  onClick={() => onMenuSelected(menu.name)}
                >
                  {<menu.icon aria-hidden="true" />}
                  {menu.name}
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Transition>
  </Menu>
)

export default DropdownGeneral